<template>
    <article class="article">
        <p class="fwbd mt20 tc">咨询服务协议</p>
        <p class="fwbd mt20">特别提醒：在您确认签署本协议之前，请您务必仔细阅读本协议所有条款，尤其是以粗体及下划线标注的条款，一旦您在贷款人、服务方或其合作方的网站或其他与本贷款相关的软件客户端（以下简称“贷款服务平台”）点击接受本协议，即意味您已充分理解本协议所有条款的含义及相应的法律后果，不可撤销地同意您作为借款人与本协议服务方以数据电文形式订立本协议并接受本协议约束。</p>
        <p class="fwbd mt20">甲方（借款人）：【系统自动填充】</p>
        <p>身份证号码：【系统自动填充】</p>
        <p>住址：【系统自动填充】</p>
        <p>电话：【系统自动填充】</p>

        <p class="fwbd mt20">乙方：深圳众联商务有限公司</p>
        <p>地址：</p>
        <p>电话：</p>
        <p>传真：</p>

        <p class="txin">甲方是中华人民共和国公民，年满【】周岁以上，【】周岁以下，具有完全民事行为能力。乙方是一家在中国境内合法存续的法人机构，具有相应的咨询服务资质。</p>
        <p class="txin">乙方依据本协议为甲方提供由华瑞银行股份有限公司（以下简称“华瑞银行”）提供的贷款相应的咨询服务，甲方接受本协议项下乙方提供的服务、并履行本协议项下对乙方的义务。</p>
        <p class="txin">现甲、乙双方根据平等、自愿原则，达成如下协议：</p>

        <p class="fwbd mt20">一、服务内容</p>
        <p class="txin">乙方为甲方提供如下咨询服务：</p>
        <p>1、安排甲方通过乙方渠道进行必要的借款信息发布；</p>
        <p>2、居间撮合甲方与华瑞银行成立借贷关系，签署相应的《借款合同》；</p>
        <p class="fwbd">3、接受甲方委托授权，为甲方从贷款服务平台提供的甲方银行账户扣收贷款本息及相关逾期费用、应缴纳的咨询相关费用等资金。</p>
        <p>4、协助华瑞银行和华瑞银行合作的保险公司要求甲方在贷款的归还日支付借款合同约定的到期还款本金、利息及其他相关款项；</p>
        <p>5、其他与“华瑞银行·众安保险场景贷业务”（华瑞银行与众安保险合作项下的消费类贷款信用保险服务产品，以下简称“场景贷”业务）有关的服务支持。</p>

        <p class="fwbd mt20">二、甲方权利与义务</p>
        <p>1、甲方有权向乙方了解其信用评审进度、贷款审批进度及结果；</p>
        <p>2、甲方在申请及实现贷款的全过程中，必须如实向乙方提供所要求提供的个人信息，如个人信息相关内容发生改变，甲方应当通知乙方或乙方委托的第三方机构；</p>
        <p class="fwbd">3、甲方同意乙方在借款合同约定的贷款期限内，委托第三方支付机构或银行从本协议第一条第3款约定的授权账户内划付包括但不限于应还借款本金、利息、服务费、逾期违约金（若有）及其他约定费用（若有）到乙方或款项对应收款账户；</p>
        <p>4、甲方在授权账户中必须留有足够余额，否则因账户余额不足或不可归责于乙方或乙方委托的第三方支付机构或银行的任何事由，导致无法及时扣款或扣款错误、失败，责任由甲方自行承担；</p>
        <p class="fwbd">5、如因乙方委托的第三方支付机构或银行的支付限额、系统故障等非客户原因导致扣款失败，乙方或乙方合作机构将通知甲方，甲方须在贷款服务平台主动还款页面填写信息，并主动划款至贷款人、乙方或乙方指定的服务方对应收款账户。</p>
        <p>6、甲方应按照本协议的规定向乙方支付咨询服务费及第三方杂费；</p>
        <p>7、甲方同意，甲方成功借款后，甲方有义务无条件及时配合乙方相关工作。</p>
        <p>8、甲方同意，乙方可以将甲方信息（包括但不限于身份信息、注册账户信息、交易信息、联系方式等）提供给乙方的合作方，在符合相关法律法规的合规要求下进行互通和共享。甲方知悉并同意，乙方或乙方的合作方将向相关机构查询甲方的信用记录，包括但不限于金融信用信息基础数据库、中国人民银行批准的征信机构及公安系统，用于“场景贷”业务所需之信用消费审核；同时甲方知悉并同意，乙方或乙方的合作方可能将涉及甲方的逾期还款行为上报至中国人民银行征信系统及其他合法征信机构，以作为追究甲方违约责任之手段。</p>

        <p class="fwbd mt20">三、乙方权利与义务</p>
        <p>1、乙方须向甲方提供贷款相关的全程信息咨询服务；</p>
        <p>2、乙方有权向甲方收取双方约定的咨询服务费；</p>
        <p>3、对于甲方提供给乙方的个人证件及其它各类信息，乙方有义务在本协议约定下为甲方保密；</p>
        <p>4、乙方有权通过甲方提供的个人信用信息及行为记录审核，为甲方提供借款方案建议，包括借款额度、还款期限等建议；</p>
        <p>5、乙方有权以信用审核的目的使用甲方个人信用信息。</p>

        <p class="fwbd mt20">四、费用的支付</p>
        <p class="fwbd">1、甲方同意：甲方接受乙方提供的本协议项下服务且甲方通过乙方服务借款成功的，乙方有权收取咨询相关费用。咨询相关费用分为咨询服务费及第三方杂费。其中，咨询服务费由乙方收取或由乙方委托第三方机构代为收取；第三方杂费如有，由乙方委托的第三方机构收取。</p>

        <p>2、咨询服务费金额和费率：</p>
        <p>【系统自动填充】</p>

        <p>3、甲方实际收到的借款本金金额如低于甲方与贷款人签订的《借款合同》约定的贷款本金金额的，本协议项下咨询服务费及第三方杂费根据《借款合同》约定的贷款本金金额计算；</p>
        <p class="fwbd">4、甲方同意并不可撤销地授权乙方或其委托的机构（包括但不限于第三方支付机构或银行）按照以下任一方式，收取咨询相关费用：</p>
        <p>（1）从甲方收到的贷款本金中一次性扣收该咨询服务费及第三方杂费；</p>
        <p>（2）从甲方指定银行账户一次性或分期扣收该咨询服务费及第三方杂费；</p>
        <p>5、若乙方或其委托的第三方机构未能从上述甲方授权账户中扣收的，甲方仍应承担付款义务，并按照本协议的约定支付延迟付款违约金；</p>
        <p class="fwbd">6、甲方提前偿还《借款合同》项下借款的，乙方已收取的咨询服务费及第三方杂费不予退还；按照上述第4点方式（2）分期收取费用的，甲方应该在提前偿还借款本息的同时，一次性支付后续所有的分期应收咨询服务费及第三方杂费。</p>
        <p>7、甲方未按本协议约定按时、足额向乙方支付咨询服务费或第三方杂费的，应自咨询服务费或第三方杂费应付未付之日起，按应付金额的3‰按日计收延迟付款违约金，直至乙方足额收到咨询服务费及第三方杂费之日止。</p>

        <p class="fwbd mt20">五、其他</p>
            <p>1、在本协议自甲方在贷款服务平台点击接受本协议时成立并生效；</p>
            <p>2、本协议双方签署的电子合同与纸质合同（如有）具有同等法律效力，均对签署双方具有拘束力；</p>
            <p>3、因签订、履行、解释本合同发生的纠纷，甲乙双方应友好协商解决，协商不成的，提交乙方所在地人民法院诉讼解决。</p>

        <p class="tc mt20">（以下为签章处，无正文）</p>

        <p class="mt50">甲方：（电子签章）</p>
        <p>【系统填充】年【系统填充】月【系统填充】日</p>


        <p class="mt50">乙方：（电子签章）</p>
        <p>【系统填充】年【系统填充】月【系统填充】日</p>
    </article>
</template>

<script>
    export default {
        beforeRouteEnter (to, from, next) {
            document.title = '咨询服务协议'
            next()
        }
    }
</script>


// WEBPACK FOOTER //
// advicecontract.vue?ce25d288